// if a condition succeeds, return a plural form. else, return a singular form
// the most common singular form is an empty string.
// the most common plural form is 's'
// you can supply two verbs instead.
export const pluralize = (condition: boolean, singularForm = '', pluralForm = 's'): string =>
  condition ? pluralForm : singularForm;

// generally, in english, 'zero' modifies grammatically plural nouns.
// e.g. "Zero snakes are in the garden. One insect is in the garden. Two cats are in the garden."
export const isPluralArray = (array: any[]): boolean => array.length !== 1;
